import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import RetirementPlannerContainer from './RetirementPlannerContainer';

const RetirementPlannerContainerEditConfig = {
  emptyLabel: 'Retirement Planner Container',
  isEmpty: function(props: any): boolean {
    return !props;
  },
};

interface Props {
  title: string;
  linkLabel: string;
  onTrack: string;
  offTrack: string;
}

class RetirementPlannerContainerWrapper extends Component<Props> {
  render(): JSX.Element {
    return <RetirementPlannerContainer {...this.props} />;
  }
}

export default MapTo('workplace-spa/components/retirementplannercontainer')(
  RetirementPlannerContainerWrapper,
  RetirementPlannerContainerEditConfig,
);
